export default "__VITE_ASSET__kt5DVDI9__"